module.exports = __webpack_public_path__ + "assets/img/b1baa1046560d01a80d8e7597a14c67c.webp";